/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-certificate-expander';
const prefix = `${moduleName}.${componentName}`;

export const revocationReasonLabel = `${prefix}.revocationReasonLabel`;
export const ocspResponseFromResponderUrlLabel = `${prefix}.ocspResponseFromResponderUrlLabel`;
export const nextUpdateLabel = `${prefix}.nextUpdateLabel`;
export const certStatusLabel = `${prefix}.certStatusLabel`;
export const revocationTimeLabel = `${prefix}.revocationTimeLabel`;
export const thisUpdateLabel = `${prefix}.thisUpdateLabel`;
export const hyphenLabel = `${prefix}.hyphenLabel`;

export const ENGLISH = {
    [revocationReasonLabel]: 'Revocation Reason',
    [ocspResponseFromResponderUrlLabel]: 'OCSP Response from Responder URL',
    [nextUpdateLabel]: 'Next Update',
    [certStatusLabel]: 'Cert Status',
    [revocationTimeLabel]: 'Revocation Time',
    [thisUpdateLabel]: 'This Update',
    [hyphenLabel]: '-',
};
